import { render } from "./StartPageArenaDefault.vue?vue&type=template&id=d750df2a"
import script from "./StartPageArenaDefault.vue?vue&type=script&lang=js"
export * from "./StartPageArenaDefault.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d750df2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d750df2a', script)) {
    api.reload('d750df2a', script)
  }
  
  module.hot.accept("./StartPageArenaDefault.vue?vue&type=template&id=d750df2a", () => {
    api.rerender('d750df2a', render)
  })

}

script.__file = "src/components/StartPageArenaDefault.vue"

export default script